export default "__VITE_ASSET__9f9d0e5f__"